export default __webpack_public_path__ + "static/media/companies.8ffc8834.png";